namespace $ { $mol_style_attach( "piterjs/logo/logo.view.css",
 "[piterjs_logo] {\n\tdisplay: block;\n\twidth: 15vmin;\n\tbox-shadow: none;\n\tmargin: 1.5vmin;\n}\n"
) }